import { compose } from 'ramda';
import { connect } from 'react-redux';
import { defaultProps } from 'recompose';

import FiltersRow from '@/components/FiltersRow';
import {
  removeFilters,
  updateFilters,
} from '@/features/storeBonusesPage/actions';
import { filterTypes } from '@/features/storeBonusesPage/filters';
import { getFilters } from '@/features/storeBonusesPage/selectors';

const mapStateToProps = state => ({
  filters: getFilters(state),
});

const mapDispatchToProps = { removeFilters, updateFilters };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  defaultProps({ filterTypes }),
)(FiltersRow);
